
/**
 *  Dashboard Module
 */
export const Dashboard = (function(){

    /**
     * Load function that is called when the Dashboard file is loaded.
     */
    var load = function () {

      // Load any tables with dashboard table
      $('.dashboard-table').each(function () {
          Dashboard.table.load(this);
      });
      
    }

    /**
     * Variable with code relating to table functions.  
     */
    var table = {

      element: null,

      load : function (tableObj, callback = null) {
          
          Dashboard.table.element = tableObj;

          if( tableObj.hasAttribute('data-data')){
              let tableData = JSON.parse(tableObj.getAttribute("data-data"))
              Dashboard.table.set(tableData, tableObj);
          }else{
            // Data is ajax
            this.getData(tableObj)
              .then(function (response) { 
                Dashboard.table.set(response, tableObj);
              })
              .then(function (response) { 
                if(callback)
                  Dashboard.table.postHook(response, tableObj, callback);
              });
          }


      },

      /**
       * Get the data from the `data-endpoint` attibute on the table.  
       * 
       * @param {*} tableObj 
       */
      getData: function (tableObj) {

        var tableEndpoint = $(tableObj).attr("data-endpoint");
              
        return $.ajax({
            url: tableEndpoint,
            type: 'GET',
            headers: { 'isAPI': true },
            statusCode: {
                403: function(response) {
                        Dashboard.table.setDenied(response, tableObj);
                },         
            }
        })
      },

      set: function (data, tableObj) {

          var payload = []
          for (var element in data) {
              payload.push(data[element]);
          }

          setTimeout(function(){ 
            
            $(tableObj).bootstrapTable({
  
                data:payload
  
            });

          }, 100)
      },

      setDenied: function (response, tableObj) {
        $(tableObj).html(response['responseText']);
      },

      postHook: function (data, tableObj, callback) {
          callback(data, tableObj);
      } ,

      /**
       * Filter function to which uses the bootstrapTable `filterBy` function.
       * We pass a field column in the table to filter and a value.  
       * If no params are passed, the filter is cleared.  
       * 
       * @param {*} field - the field that we want to filter on @example status
       * @param {*} value - the value we are filtering on @example ACTIVE
       */
      filterBy: function( field = null, value = null ) {
        /**
         * If no parameter passed, clear fitler
         */
        if(!field || !value ){
          return $(this.element).bootstrapTable('filterBy');
        }
        /**
         * Otherwise, filter on the data-status of the button
         */
        var options = {};
        options[field] = [value];
        $(this.element).bootstrapTable('filterBy', options);
      },

      refresh: function () {

        setTimeout(function(){ 
            
          $('#table_invited_citizens').bootstrapTable('refresh');

      }, 500)
      },

      /**
       * linkFormatter for Bootsrap-Table. 
       * 
       * When this is defined as the value of the `data-formatter` attributes on an <th> element in a bootstrap table
       * this will format the cell as a link and use the @var row['mydexid'] as the href
       * @param {*} value inside the <th> element
       * @param {*} row object containing the entire row content
       */
      linkFormatter : function (value, row){
        return "<a href='citizen/"+row['mydexid']+"'>"+value+"</a>";
      },
      /**
       * linkFormatterOffer for Bootsrap-Table. 
       * 
       * When this is defined as the value of the `data-formatter` attributes on an <th> element in a bootstrap table
       * this will format the cell as a link and use the @var row['mydexid'] as the href
       * @param {*} value inside the <th> element
       * @param {*} row object containing the entire row content
       */
      linkFormatterOffer : function (value, row){
        return "<a href='/citizen/"+row['mydexid']+"'>"+value+"</a>";
      },
      /**
       * iconFormatter for Bootsrap-Table. 
       * 
       * When this is defined as the value of the `data-formatter` attributes on an <th> element in a bootstrap table
       * this will format the cell as a icon.  If the value is `INVITE` the icon with be a envelope
       * if the valus is `SELFREG` the icon is a tick
       * @param {*} value inside the <th> element
       */
      iconFormatter : function (value) {
        if(value === 'INVITE'){
            return `<div class="d-flex justify-content-center">
                      <img style="max-width: 30px" class="img-fluid d-flex justify-content-center"  src="static/images/icons/noun_TYPE_INVITE.svg" title='Member was invited to the platform' alt='Member was invited to the platform'>
                    </div>`;
        }else if(value === 'SELFREG'){
          return `<div class="d-flex justify-content-center">
                    <img style="max-width: 35px" class="img-fluid d-flex justify-content-center" src="static/images/icons/noun_TYPE_SELF.svg" title='Member self-registered to the platform' alt='Member self-registered to the platform'>
                  </div>`;
        }else{
            return "-"
        }
      },
      /**
       * choiceFormatter for Bootsrap-Table. 
       * 
       * When this is defined as the value of the `data-formatter` attributes on an <th> element in a bootstrap table
       * this will format the cell as a button which will call `InvitesModule.invites.openInvitesModal(email)` with the 
       * @param value - required even though not used because the arguments are position DONT REMOVE
       * @param row - full row object
       * @var row['field_personal_email_address']
       */
      inviteFormatter : function (value,row) {
        
        return `<div class="d-flex justify-content-center">
                  <a onclick=InvitesModule.invites.openOfferInvitesModal('${row['mydexid']}','${row['field_personal_fname']}','${row['field_personal_faname']}') class="btn btn-secondary">Send Invite</a>
                </div>`;
      },
      /**
       * iconFormatter for Bootsrap-Table. 
       * 
       * When this is defined as the value of the `data-formatter` attributes on an <th> element in a bootstrap table
       * this will format the cell as a icon. 
       * @param {*} value inside the <th> element
       */
      choiceFormatter : function (value) {

        if(value === 'YES'){
            return `<div class="d-flex justify-content-center">
                      <img style="max-width: 32px" class="img-fluid d-flex justify-content-center"  src="/static/images/icons/noun_RESPONSE_YES.svg" title='Member responded Yes to the offer' alt='Member responded Yes to the offer'>
                    </div>`;
        }else if(value === 'NO'){
          return `<div class="d-flex justify-content-center">
                    <img style="max-width: 36px" class="img-fluid d-flex justify-content-center" src="/static/images/icons/noun_RESPONSE_NO.svg" title='Member responded No to the offer' alt='Member responded No to the offer'>
                  </div>`;
        }else if(value === 'MAYBE'){
          return `<div class="d-flex justify-content-center">
                    <img style="max-width: 26px" class="img-fluid d-flex justify-content-center" src="/static/images/icons/noun_RESPONSE_MAYBE.svg" title='Member responded Maybe to the offer' alt='Member responded Maybe to the offer'>
                  </div>`;
        }
        else{
          return `<div class="d-flex justify-content-center">
                    <img style="max-width: 26px" class="img-fluid d-flex justify-content-center" src="/static/images/icons/noun_FORM_NOT_STARTED.svg" title='The Member has not responded to the offer' alt='Member responded Maybe to the offer'>
                  </div>`;
        }
      },
      /**
       * formStatusFormatter for Bootsrap-Table. 
       * 
       * When this is defined as the value of the `data-formatter` attributes on an <th> element in a bootstrap table
       * this will format the cell as a icon. 
       * @param {*} value inside the <th> element
       */
      formStatusFormatter : function (value, row) {
        
        
        switch (row['form_status']) {

          case "NOT_STARTED":

            
            return `<div class="d-flex justify-content-center">
                    <img style="max-width: 26px" class="img-fluid d-flex justify-content-center"  src="/static/images/icons/noun_FORM_NOT_STARTED.svg" title='The member has not started the form' alt='The member has not started the form'>
                  </div>`;  

          case 'IN_PROGRESS':


            return `<div class="d-flex justify-content-center">
                      <img style="max-width: 24px" class="img-fluid d-flex justify-content-center" src="/static/images/icons/noun_FORM_IN_PROGRESS.svg" title='The members form is in progress' alt='The members form is in progress'>
                    </div>`;     
        
          case 'AWAITING_SIGNATURE':

            return `<div class="d-flex justify-content-center">
                      <img style="max-width: 24px" class="img-fluid d-flex justify-content-center" src="/static/images/icons/noun_FORM_AWAITING_SIGNATURE.svg" title='The members form is complete awaiting signature.' alt='The members form is complete awaiting signature'>
                    </div>`;            
        
          case 'COMPLETE':

            return `<div class="d-flex justify-content-center">
                      <img style="max-width: 24px" class="img-fluid d-flex justify-content-center" src="/static/images/icons/noun_FORM_COMPLETE.svg" title='The members form is complete. Click the member to view' alt='The members form is complete awaiting signature'>
                    </div>`;              
        
        
          case 'COMPLETE_WITH_SIGNATURE':

            return `<div class="d-flex justify-content-center">
                      <img style="max-width: 26px" class="img-fluid d-flex justify-content-center" src="/static/images/icons/noun_FORM_COMPLETE_WITH_SIGNATURE.svg" title='The members form is complete awaiting signature' alt='The members form is complete awaiting signature'>
                    </div>`;  
        
          default:
            break;
        }
      },
            /**
       * iconFormatter for Bootsrap-Table. 
       * 
       * When this is defined as the value of the `data-formatter` attributes on an <th> element in a bootstrap table
       * this will format the cell as a icon. 
       * @param {*} value inside the <th> element
       */
      buttonFormatter : function (value) {

          return `<div class="d-flex justify-content-center">
                    <button class="btn btn-primary"> Send Message</button>
                  </div>`;

      },
    }

    /** Helper Functions */
    function dateFormatter(date) {
          // Unixtimestamp
          var unixtimestamp = date;
          // Months array
          var months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          // Convert timestamp to milliseconds
          var date = new Date(unixtimestamp * 1000);
          // Year
          var year = date.getFullYear();
          // Month
          var month = months_arr[date.getMonth()];
          var month1 = months_arr.indexOf(month) + 1;
          // Day
          var day = date.getDate();
          var convdataTime = day + '/' + month1 + '/' + year;

          return convdataTime;

    }

    return {
      load:load,
      table:table,
      dateFormatter:dateFormatter
    }
  
}());









